import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useId, } from 'react';
import { inputClasses } from './styles.js';
import { useUiV2 } from './v2.js';
/**
 * 素の入力欄 primitive。ラベル/エラーが不要な場面（テーブルセル等）で単体利用する。
 * ラベル付きで使うときは TextField を使う。
 */
export const Input = forwardRef(function Input({ invalid, size, fullWidth, v2, surface, className, ...rest }, ref) {
    const isV2 = useUiV2(v2);
    return (_jsx("input", { ref: ref, className: inputClasses({ invalid, size, fullWidth, v2: isV2, surface, className }), ...rest }));
});
/**
 * ラベル + 入力 + エラー/補足をまとめたフォーム項目。label は htmlFor で input に
 * 関連付けられ（id 未指定なら useId で自動採番）、required は視覚的に「*」を表示する。
 */
export const TextField = forwardRef(function TextField({ label, error, hint, required, id, size, fullWidth, v2, surface, className, ...rest }, ref) {
    const autoId = useId();
    const fieldId = id ?? autoId;
    const hasError = error != null && error !== false;
    const isV2 = useUiV2(v2);
    return (_jsxs("div", { children: [label != null && (_jsxs("label", { htmlFor: fieldId, className: isV2
                    ? 'mb-1.5 block text-label font-medium text-ink-2'
                    : 'mb-1 block text-sm font-medium text-foreground', children: [label, required && (_jsx("span", { className: isV2 ? 'ml-0.5 text-danger-ink' : 'ml-0.5 text-destructive', "aria-hidden": "true", children: "*" }))] })), _jsx(Input, { ref: ref, id: fieldId, required: required, invalid: hasError, "aria-invalid": hasError || undefined, size: size, fullWidth: fullWidth, v2: isV2, surface: surface, className: className, ...rest }), hasError ? (_jsx("p", { className: isV2 ? 'mt-1.5 text-label text-danger-ink' : 'mt-1 text-xs text-destructive', children: error })) : (hint != null && (_jsx("p", { className: isV2 ? 'mt-1.5 text-label text-ink-3' : 'mt-1 text-xs text-muted-foreground', children: hint })))] }));
});
//# sourceMappingURL=Input.js.map